module.exports = __webpack_public_path__ + "img/Vector3.366b9642.svg";